import AddEditSection from "../../components/AddEditSection";
import Breadcrumb from "../../parts/Breadcrumb";
import React, { useEffect, useState } from "react";
import configuration from "../../config";
import { toast } from "react-toastify";
import labels from "../../constants/Language";
import _ from "underscore";
import { getAccessRights } from "../../utils/common";
import Loader from "../../components/Loader/Loader";

// For Edit Language
let Id = "";

function Edit({ history }) {
  const [countryOpt, setCountryOpt] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const statusOpt = [
    { id: 1, title: "Active", value: "active" },
    { id: 2, title: "Inactive", value: "inactive" },
    { id: 3, title: "Archive", value: "archive" },
  ];

  const [fieldArr, setFieldArr] = useState([
    { id: 0, title: "Title", name: "title", type: "TextInput" },
    {
      id: 1,
      title: "Code",
      name: "code",
      type: "TextInput",
      is_read_only: true,
    },
    {
      id: 0,
      title: "Country",
      name: "country_id",
      type: "Dropdown",
      options: countryOpt,
    },
    {
      id: 3,
      title: "Status",
      name: "status",
      type: "Dropdown",
      options: statusOpt,
    },
    { id: 0, title: "Flag ", name: "flag", type: "FileInput" },
  ]);
  const [fields, setFields] = useState({});
  const [errors, setErrors] = useState({
    title: "",
    code: "",
  });
  const [icon, setIcon] = useState(null);

  function handleValidation() {
    let flag = true;
    let error = {};
    if (!fields.title) {
      error["title"] = "Please enter language title";
      flag = false;
    }

    if (!fields.code) {
      error["code"] = "Please enter language code";
      flag = false;
    }
    if (!fields.order_no) {
      error["order_no"] = "Please select order no";
      flag = false;
    }
    if (!fields.country_id) {
      error["country_id"] = "Please select country";
      flag = false;
    }
    if (!fields.status) {
      error["status"] = "Please select status";
      flag = false;
    }
    setErrors({ ...error });
    return flag;
  }

  useEffect(() => {
    getAccessRights().then((rights) => {
      const rightsData = rights?.find((ac) => ac.code === "LANGUAGE");
      if (rightsData?.edit === false) {
        history.push("/dashboard");
      }
    });
    setIsLoader(true);
    getCountryDatas();
    var url = window.location.href;
    Id = url.substring(url.lastIndexOf("/") + 1);
    configuration
      .getAPI({ url: "language/list", params: { language_id: Id } })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          setFields(data.payload);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
    configuration
      .getAPI({
        url: "common/list-order-no",
        params: {
          collectionName: "languages",
          lang_code: "EN",
          is_update: 1,
        },
      })
      .then((data) => {
        if (data.status === 200) {
          let orderNoArr = [];
          _.each(data.payload, (singleRec) => {
            orderNoArr.push({
              title: singleRec.title,
              value: singleRec.order_no,
              id: singleRec.order_no,
            });
          });
          const orderNoObj = {
            id: 1,
            title: "Order No",
            name: "order_no",
            type: "Dropdown",
            options: orderNoArr,
          };
          setFieldArr((prevFields) => [...prevFields, orderNoObj]);
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }, []);

  function getCountryDatas() {
    configuration
      .getAPI({ url: "country/list", params: {} })
      .then((data) => {
        if (data.status === 200) {
          let countryOptions = [];
          if (data.payload.length > 0) {
            countryOptions = data.payload.map((element) => ({
              title: element.name,
              value: element.country_id,
              id: element.country_id,
            }));
          }

          setCountryOpt(countryOptions);
          console.log("countryOptions");
          console.log(countryOptions);

          // Update the specific field in fieldArr
          setFieldArr((prevFields) =>
            prevFields.map((field) =>
              field.name === "country_id"
                ? { ...field, options: countryOptions }
                : field
            )
          );
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }

  function handleChange(field, e) {
    if (field === "flag") {
      setIcon(e.target.files[0]);
      setFields({ ...fields, [field]: URL.createObjectURL(e.target.files[0]) });
    } else {
      setFields({ ...fields, [field]: e.target.value });
    }
  }

  const handleSubmit = () => {
    if (handleValidation()) {
      setIsLoader(true);
      const formData = new FormData();
      if (icon) {
        formData.append("icon", icon);
      }
      formData.append("fields", JSON.stringify({ ...fields, lang_code: "EN" }));
      configuration
        .postFormDataAPI({ url: "language/update", params: formData })
        .then((data) => {
          setIsLoader(false);
          if (data.status === 200) {
            history.push("/language");
            toast.success("Record updated successfully");
          } else if (data.error) {
            return toast.error(data.error.message);
          } else {
            return toast.error("Something went wrong");
          }
        })
        .catch((error) => {
          setIsLoader(false);
          return toast.error(error.message);
        });
    }
  };
  function cancleImage(field, e) {
    setIcon(null);
    setFields({ ...fields, [field]: "" });
  }

  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.editLanguage} />
      <AddEditSection
        title="Edit Language"
        path="/language"
        fields={fieldArr}
        fieldError={errors}
        fieldValue={fields}
        handleChange={handleChange}
        cancleImage={cancleImage}
        handleSubmit={handleSubmit}
      />
    </>
  );
}

export default Edit;
